const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'API-toegang',
    apiAppContent: `Met de Enlighten Systems API kunnen software-ontwikkelaars externe applicaties schrijven die systeemproductiegegevens lezen. Deze applicaties kunnen u vragen om een gebruikers-ID in te voeren om namens u API-aanvragen te doen. Uw gebruikers-ID is %{user_id}.`,
    showApp: 'Toon applicaties die toegang tot API hebben',
    isGrantedApp: 'U heeft API geen toegang verleend tot enige applicatie.',
    apiSystemContent:
      'Een externe applicatie kan alleen gegevens ophalen voor systemen die API-toegang toestaan. Dit wordt gecontroleerd door de systeemeigenaar. Als een systeem dat u kunt bekijken niet in de lijst staat, komt dat omdat de eigenaar ervoor heeft gekozen om geen API-toegang toe te staan.',
    showSystem: 'Toon systemen die API-toegang toestaan',
    isGrantedSystem: 'U heeft geen API-toegang verleend tot systemen.',
    revokeAccess: 'Herroeping van de toegangsrechten'
  }
};

export default apiAccess;
